<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import AlertBox from '@/components/Elements/Alerts/AlertBox.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_technology_tree')
}

const isOnResearchSection = computed(() => {
  return route.path.startsWith('/research')
})

const goToResearch = () => {
  router.push('/research')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/science.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.technologyTree.welcome') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.technologyTree.showsHow') }}
      </p>
      <p class="pb-2">
        <i18n-t keypath="tutorial.technologyTree.colorMeaning" tag="span">
          <template #blue><span class="text-blue-500">{{ t('tutorial.technologyTree.blue') }}</span></template>
          <template #yellow><span class="text-yellow-500">{{ t('tutorial.technologyTree.yellow') }}</span></template>
          <template #green><span class="text-green-500">{{ t('tutorial.technologyTree.green') }}</span></template>
        </i18n-t>
      </p>
    </template>

    <template #alerts>
      <AlertBox type="info" class="hidden md:flex">
        {{ t('tutorial.technologyTree.tryClickDesktop') }}
      </AlertBox>
      <AlertBox type="info" class="md:hidden">
        {{ t('tutorial.technologyTree.tryClickMobile') }}
      </AlertBox>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnResearchSection" @click="goToResearch" class="mr-2">
        {{ t('tutorial.technologyTree.goToResearch') }}
      </ActionButton>
      <ActionButton @click="handleNextStep">
        {{ t('tutorial.technologyTree.howToPick') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>